module.exports = __webpack_public_path__ + "static/policy_book2_2@2x-69e680179f5f0b5ca560a332fbe68844.png";